export default window._cmsContent['solar/global-banner']